import { render, staticRenderFns } from "./ForestersLiveWellPlusInstructions.vue?vue&type=template&id=26f39284&scoped=true&"
import script from "./ForestersLiveWellPlusInstructions.vue?vue&type=script&lang=js&"
export * from "./ForestersLiveWellPlusInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ForestersLiveWellPlusInstructions.vue?vue&type=style&index=0&id=26f39284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f39284",
  null
  
)

export default component.exports